import { Message } from "primereact/message";
import { Tag } from "primereact/tag";

import { Dialog, DialogFooter, DialogHeader, Icon } from "@/ds";
import { JustificativaField } from "@/shared/components";
import modal from "../planejamento-controle.modal.module.scss";
import {
  CANCELAR_LABEL,
  COTACAO_VIGENTE_LABEL,
  NOVA_COTACAO_LABEL,
  O_QUE_ACONTECE_TITLE,
  SOLICITAR_COTACAO_INTRO,
  SOLICITAR_COTACAO_TITLE,
  SOLICITAR_LABEL,
} from "./solicitar-cotacao-dialog.constants";
import styles from "./solicitar-cotacao-dialog.module.scss";
import type { SolicitarCotacaoDialogViewModel } from "./types-solicitar-cotacao-dialog";

const RODAPE_DIALOGO = { footer: { className: modal.dialogoRodape } };

export function SolicitarCotacaoDialogView({
  formId,
  moedaCodigo,
  moedaNome,
  vigente,
  nova,
  aviso,
  justificativa,
  justificativaError,
  isSubmitting,
  submitError,
  digitarJustificativa,
  enviar,
  cancelar,
}: SolicitarCotacaoDialogViewModel) {
  return (
    <Dialog
      visible
      size="md"
      className={styles.dialogo}
      contentClassName={styles.corpo}
      onHide={cancelar}
      locked={isSubmitting}
      focusOnShow={false}
      header={<DialogHeader title={SOLICITAR_COTACAO_TITLE} />}
      pt={RODAPE_DIALOGO}
      footer={
        <DialogFooter
          className={modal.rodape}
          cancelLabel={CANCELAR_LABEL}
          confirmLabel={SOLICITAR_LABEL}
          formId={formId}
          loading={isSubmitting}
          locked={isSubmitting}
          onCancel={cancelar}
          testId="solicitar-cotacao"
        />
      }
      data-testid="solicitar-cotacao-dialog"
    >
      <form id={formId} className={styles.form} onSubmit={enviar} noValidate>
        <p className={styles.texto}>{SOLICITAR_COTACAO_INTRO}</p>
        <div className={styles.resumo} data-testid="solicitar-cotacao-resumo">
          <span className={styles.moedaLinha}>
            <strong className={styles.moeda}>{moedaCodigo}</strong>
            {moedaNome ? (
              <Tag
                value={moedaNome}
                severity="secondary"
                data-testid="solicitar-cotacao-moeda-nome"
              />
            ) : null}
          </span>
          <p className={styles.taxas}>
            {COTACAO_VIGENTE_LABEL} <strong>{vigente}</strong>
            <Icon name="arrow-right" size={12} />
            {NOVA_COTACAO_LABEL} <strong data-testid="solicitar-cotacao-nova">{nova}</strong>
          </p>
        </div>
        <section>
          <h3 className={styles.subtitulo}>{O_QUE_ACONTECE_TITLE}</h3>
          <p className={styles.texto} data-testid="solicitar-cotacao-aviso">
            {aviso}
          </p>
        </section>
        <JustificativaField
          labelClassName={modal.rotuloCampo}
          rows={2}
          value={justificativa}
          onChange={digitarJustificativa}
          error={justificativaError}
          disabled={isSubmitting}
          testIds={{
            campo: "solicitar-cotacao-justificativa",
            contador: "solicitar-cotacao-contador",
            erro: "solicitar-cotacao-justificativa-error",
          }}
        />
        {submitError ? (
          <Message
            className="p-message-block"
            severity="error"
            text={submitError}
            data-testid="solicitar-cotacao-submit-error"
          />
        ) : null}
      </form>
    </Dialog>
  );
}
